import React from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import Whatsapp from '../components/Whatsaapp';

const styles = {
  privacyContainer: {
    padding: '50px 20px',
    backgroundColor: '#181A1B', // dark background
    minHeight: '100vh',
  },
  contentWrapper: {
    maxWidth: '1000px',
    margin: '0 auto',
    backgroundColor: '#23272A', // darker card
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 16px rgba(0,0,0,0.7)',
  },
  h1: {
    fontSize: '2.5rem',
    color: '#F3F4F6', // light text
    textAlign: 'left',
    marginBottom: '10px',
    fontWeight: '700',
  },
  lastUpdated: {
    fontSize: '0.9rem',
    color: '#A0A0A0',
    textAlign: 'left',
    marginBottom: '40px',
    fontStyle: 'italic',
  },
  section: {
    marginBottom: '30px',
    paddingBottom: '15px',
    borderBottom: '1px solid #333', // darker border
  },
  h2: {
    fontSize: '1.8rem',
    color: '#E5E7EB',
    marginBottom: '15px',
    paddingBottom: '10px',
    borderBottom: '1px solid #222',
    textAlign: 'left',
  },
  paragraph: {
    fontSize: '1rem',
    lineHeight: '1.6',
    color: '#D1D5DB',
    marginBottom: '15px',
    textAlign: 'left',
  },
  list: {
    paddingLeft: '20px',
    margin: '15px 0',
    fontSize: '1rem',
    lineHeight: '1.5',
    color: '#D1D5DB',
    textAlign: 'left',
  },
  listItem: {
    marginBottom: '10px',
    textAlign: 'left',
  },
  contactInfo: {
    backgroundColor: '#23272A',
    padding: '15px',
    borderRadius: '5px',
    marginTop: '15px',
    textAlign: 'left',
    border: '1px solid #333',
  },
};

const PrivacyWithStyles = () => {
  return (
    <>
      <Header />
      
      <div style={styles.privacyContainer}>
        <div style={styles.contentWrapper}>
          <h1 style={styles.h1}>Privacy Policy</h1>
          <p style={styles.lastUpdated}>Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
          
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(section => (
            <section key={section} style={styles.section}>
              {section === 1 && (
                <>
                  <h2 style={styles.h2}>1. Introduction</h2>
                  <p style={styles.paragraph}>
                    Welcome to Travelscape Tours. We respect your privacy and are committed to protecting your personal data. 
                    This privacy policy will inform you about how we look after your personal data when you visit our website 
                    and tell you about your privacy rights and how the law protects you.
                  </p>
                </>
              )}
              
              {section === 2 && (
                <>
                  <h2 style={styles.h2}>2. Information We Collect</h2>
                  <p style={styles.paragraph}>
                    We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:
                  </p>
                  <ul style={styles.list}>
                    <li style={styles.listItem}><strong>Identity Data</strong> includes first name, last name, username or similar identifier.</li>
                    <li style={styles.listItem}><strong>Contact Data</strong> includes billing address, delivery address, email address, and telephone numbers.</li>
                    <li style={styles.listItem}><strong>Financial Data</strong> includes payment card details.</li>
                    <li style={styles.listItem}><strong>Transaction Data</strong> includes details about payments to and from you and other details of products and services you have purchased from us.</li>
                    <li style={styles.listItem}><strong>Technical Data</strong> includes internet protocol (IP) address, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform, and other technology on the devices you use to access this website.</li>
                    <li style={styles.listItem}><strong>Usage Data</strong> includes information about how you use our website, products, and services.</li>
                  </ul>
                </>
              )}
              
              {section === 3 && (
                <>
                  <h2 style={styles.h2}>3. How We Use Your Information</h2>
                  <p style={styles.paragraph}>We use your personal data for the following purposes:</p>
                  <ul style={styles.list}>
                    <li style={styles.listItem}>To register you as a new customer</li>
                    <li style={styles.listItem}>To process and deliver your booking</li>
                    <li style={styles.listItem}>To manage your relationship with us</li>
                    <li style={styles.listItem}>To improve our website, products/services, marketing, and customer relationships</li>
                    <li style={styles.listItem}>To recommend trips or special offers that may be of interest to you</li>
                    <li style={styles.listItem}>To comply with legal obligations</li>
                  </ul>
                </>
              )}
              
              {section === 4 && (
                <>
                  <h2 style={styles.h2}>4. Information Sharing and Disclosure</h2>
                  <p style={styles.paragraph}>
                    We may share your personal information with the following parties:
                  </p>
                  <ul style={styles.list}>
                    <li style={styles.listItem}><strong>Service Providers:</strong> We share information with third-party vendors who help us operate our business.</li>
                    <li style={styles.listItem}><strong>Travel Partners:</strong> Hotels, airlines, tour operators, and other travel service providers necessary to complete your booking.</li>
                    <li style={styles.listItem}><strong>Legal Requirements:</strong> We may disclose your information if required by law or if we believe in good faith that such action is necessary to comply with applicable laws.</li>
                  </ul>
                </>
              )}
              
              {section === 5 && (
                <>
                  <h2 style={styles.h2}>5. Data Security</h2>
                  <p style={styles.paragraph}>
                    We have implemented appropriate security measures to prevent your personal data from being accidentally lost, used, 
                    accessed in an unauthorized way, altered, or disclosed. We limit access to your personal data to those employees, 
                    agents, contractors, and other third parties who have a business need to know.
                  </p>
                </>
              )}
              
              {section === 6 && (
                <>
                  <h2 style={styles.h2}>6. Cookie Policy</h2>
                  <p style={styles.paragraph}>
                    Our website uses cookies to distinguish you from other users of our website. This helps us to provide you with a good 
                    experience when you browse our website and also allows us to improve our site.
                  </p>
                </>
              )}
              
              {section === 7 && (
                <>
                  <h2 style={styles.h2}>7. Your Legal Rights</h2>
                  <p style={styles.paragraph}>
                    Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to:
                  </p>
                  <ul style={styles.list}>
                    <li style={styles.listItem}>Request access to your personal data</li>
                    <li style={styles.listItem}>Request correction of your personal data</li>
                    <li style={styles.listItem}>Request erasure of your personal data</li>
                    <li style={styles.listItem}>Object to processing of your personal data</li>
                    <li style={styles.listItem}>Request restriction of processing your personal data</li>
                    <li style={styles.listItem}>Request transfer of your personal data</li>
                    <li style={styles.listItem}>Right to withdraw consent</li>
                  </ul>
                </>
              )}
              
              {section === 8 && (
                <>
                  <h2 style={styles.h2}>8. Changes to the Privacy Policy</h2>
                  <p style={styles.paragraph}>
                    We may update our privacy policy from time to time. We will notify you of any changes by posting the new 
                    privacy policy on this page and updating the "Last Updated" date at the top of this privacy policy.
                  </p>
                </>
              )}
              
              {section === 9 && (
                <>
                  <h2 style={styles.h2}>9. Contact Us</h2>
                  <p style={styles.paragraph}>
                    If you have any questions about this privacy policy or our privacy practices, please contact us at:
                  </p>
                  <div style={styles.contactInfo}>
                    <p style={styles.paragraph}>
                      Email: bookings@travelscapetours.com<br />
                      Phone: +91 8799982010<br />
                      Address: Mumbai</p>
                  </div>
                </>
              )}
            </section>
          ))}
        </div>
      </div>
      
      <Whatsapp />
      <Footer />
    </>
  );
};

export default PrivacyWithStyles;
